<template>
  <div class="exchange">
    <div class="exchange-info">
      <!-- 收货信息 -->
      <div class="exchange-address">
        <div class="df aic jcsb">
          <span class="mic-semblod fs-22 lh-30 c-19">{{ $t("收货信息") }}</span>
          <el-button type="text" class="address-addbtn" @click="onAddAddress"
            ><span class="iconfont mr-4">&#xe623;</span
            >{{ $t("新增地址") }}</el-button
          >
        </div>
        <div class="df fww" style="width: 100%">
          <div
            class="exchange-address-item"
            :class="{ active: selectedAddressIndex == index }"
            v-for="(item, index) in exchangeInfo"
            :key="item.tua_id || index"
            @click="selectedAddressIndex = index"
          >
            <span
              class="iconfont close-btn"
              @click.stop="onDeleteAddress(item, index)"
            >
              &#xe67c;
            </span>
            <div class="fs-14 one-text">
              <span v-if="item.is_default === 1" class="ipt-active">{{
                $t("默认")
              }}</span>
              {{ item.address }}
            </div>
            <div class="fs-16 one-text mic-semblod">
              {{ item.addressDetail }}
            </div>
            <div class="fs-14">{{ item.name }}: {{ item.phone }}</div>
            <div class="df jcsb">
              <span class="fs-14 mt-4">
                {{ $t("邮编") }}: {{ item.postcode }}
              </span>
              <el-button
                type="text"
                class="edit-btn"
                @click.stop="onEditAddress(item, index)"
                >{{ $t("编辑") }}</el-button
              >
            </div>
          </div>
        </div>
      </div>

      <!-- 兑换详情 -->
      <div class="exchange-exchange">
        <div class="mic-semblod fs-22 lh-30 c-19">
          {{ $t("兑换详情") }}
        </div>
        <!-- 商品 -->
        <div class="commodity df">
          <div class="left-img fn">
            <img
              :src="
                commodityInfo.image ||
                'https://img1.baidu.com/it/u=4101939559,1931437443&fm=253&fmt=auto&app=138&f=JPEG?w=1067&h=800'
              "
              alt=""
            />
          </div>
          <div class="right-text f1 ml-32 pt-16">
            <div class="fs-16 lh-24 mic-semblod">
              <span class="">{{ commodityInfo.name }}</span>
              <span class="ml-110">X{{ commodityInfo.num }}</span>
              <span class="value-text ml-70">{{ commodityInfo.price }}</span>
            </div>

            <div class="lh-28 mt-56">
              <span class="fs-14 c-0" style="opacity: 0.6">{{
                $t("兑换积分")
              }}</span>
              <span class="harmonyos-text fs-20 c-19 ml-16">{{
                (Number(commodityInfo.value) || 0) *
                (Number(commodityInfo.num) || 1)
              }}</span>
              <span class="fs-14 c-0 ml-8" style="opacity: 0.6">（{{ $t("当前积分") }}：{{ Number(commodityInfo.currentPoint ?? 0) }}）</span>
            </div>
          </div>
        </div>

        <div class="btn-box df jcfe">
          <el-button type="primary" class="btn" @click="handleSubmitOrder">{{
            $t("提交订单")
          }}</el-button>
        </div>
      </div>
    </div>

    <!-- 添加地址弹框 -->
    <el-dialog
      :title="dialogMode === 'add' ? $t('新增地址') : $t('编辑地址')"
      width="726px"
      custom-class="address-dialog"
      :visible.sync="dialogTableVisible"
    >
      <el-form
        :model="addressForm"
        label-position="top"
        :rules="rules"
        ref="ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('国家')" prop="country">
              <el-select
                v-model="addressForm.country"
                filterable
                :placeholder="$t('请选择国家/区域')"
                @change="handleChangecountry"
              >
                <el-option
                  v-for="item in countryList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" prop="postal">
            <el-form-item :label="$t('邮编')">
              <el-input
                v-model="addressForm.postal"
                :placeholder="$t('请输入')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!--                <el-form-item label="地址信息" prop="addressinfo">-->
        <!--                    <el-select v-model="addressForm.addressinfo" placeholder="活动区域">-->
        <!--                        <el-option label="区域一" value="shanghai"></el-option>-->
        <!--                        <el-option label="区域二" value="beijing"></el-option>-->
        <!--                    </el-select>-->
        <!--                </el-form-item>-->

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item :label="$t('省/州')" prop="province" :rules="provinceRules">
              <el-select
                v-model="addressForm.province"
                filterable
                :placeholder="$t('请选择省/州')"
                @change="handleChangeprovince"
              >
                <el-option
                  v-for="item in provinceList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('城市')" prop="city" :rules="cityRules">
              <el-select
                v-model="addressForm.city"
                filterable
                :placeholder="$t('请选择城市')"
                @change="handleChangecity"
              >
                <el-option
                  v-for="item in cityList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('区/县')" prop="district">
              <el-input
                v-model="addressForm.district"
                :placeholder="$t('请输入')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item :label="$t('详细地址')" prop="info">
          <el-input
            type="textarea"
            :placeholder="$t('请输入详细地址信息，如小区、道路、门牌号等信息')"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="200"
            show-word-limit
            v-model="addressForm.info"
          >
          </el-input>
        </el-form-item>

        <el-row :gutter="20" class="mt-16">
          <el-col :span="12">
            <el-form-item :label="$t('收货人姓名')" prop="name">
              <el-input
                v-model="addressForm.name"
                :placeholder="$t('请输入')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('手机号')" prop="phone">
              <div class="df">
                <span class="fs-18 c-9 mr-8">+</span>
                <div class="fn mr-4" style="width: 126px">
                  <el-input
                    v-model="addressForm.area"
                    @input="handleAreaInput"
                    :placeholder="$t('区号，如 86')"
                  ></el-input>
                </div>
                <el-input
                  v-model="addressForm.phone"
                  @input="handlePhoneInput"
                  :placeholder="$t('请输入')"
                ></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="">
              <el-checkbox v-model="addressForm.checked">{{
                $t("设置为默认收货地址")
              }}</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" class="btn1" @click="handleDialogCancel">{{
          $t("取消")
        }}</el-button>
        <el-button type="primary" class="btn2" @click="handleDialogOk">{{
          $t("保存8")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 提交订单 -->
    <el-dialog
      title=""
      width="500px"
      custom-class="submit-dialog"
      :visible.sync="dialogsubmitVisible"
    >
      <div class="pb-16">
        <div class="ta-c">
          <img src="@/assets/images/journal-nodata.png" alt="" />
        </div>
        <div class="ta-c fs-18 lh-26 c-1a mt-8 mic-semblod">
          {{ $t("提交成功") }}
        </div>
        <div class="fs-14 lh-22 c-1a mt-16">
          {{ $t("订单提交成功，我们快马加鞭处理订单，为您邮寄兑换的商品！") }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import {
  addressList,
  addressSave,
  addressDelete,
  getGoodsDetail,
  exchange,
} from "@/api/pointmall";
import { getQuestionCountry } from "@/api/questionnaire";
import { getDistrict } from "@/api/user";
export default {
  name: "Exchange", //兑换
  // 收货信息
  data() {
    return {
      // 默认地址
      dialogTableVisible: false,
      // 提交订单
      dialogsubmitVisible: false,

      // 当前选择用于下单的地址索引
      selectedAddressIndex: -1,
      // 实际默认地址索引（根据 is_default 标记）
      defaultAddressIndex: -1,
      exchangeInfo: [],
      dialogMode: "add", // 'add' | 'edit'
      editingId: null,
      // 商品详情
      commodityInfo: {
        id: null,
        name: "",
        image: "",
        price: null,
        num: 1,
        // 兑换所需积分（单价）
        value: null,
        totalPrice: null,
        // 当前积分
        currentPoint: 0,
        // 是否在可兑换窗口内
        can_exchange_window: 0,
        // 当前用户是否可兑换（积分是否足够）
        can_exchange_by_user: 0,
        // 不可兑换提示（后端可配置）
        not_exchange_tips: "",
        expire: "",
      },

      // 新增地址
      addressForm: {
        // 国家
        country: "",
        postal: "",
        addressinfo: "",
        province: "",
        city: "",
        district: "",
        info: "",
        name: "",
        phone: "",
        area: "",
        checked: false,
      },
      // 地区下拉数据
      countryList: [],
      provinceList: [],
      cityList: [],
      rules: {
        country: [
          {
            required: true,
            message: this.$t("请输入国家/区域"),
            trigger: "change",
          },
        ],
        postal: [
          { required: true, message: this.$t("请输入邮编"), trigger: "blur" },
        ],
        addressinfo: [
          {
            required: true,
            message: this.$t("请输入详细地址"),
            trigger: "blur",
          },
        ],
        province: [],
        city: [],
        district: [
          { required: true, message: this.$t("请输入区/县"), trigger: "blur" },
        ],
        info: [
          {
            required: true,
            message: this.$t("请输入地址信息"),
            trigger: "blur",
          },
        ],
        name: [
          { required: true, message: this.$t("请输入姓名"), trigger: "blur" },
        ],
        phone: [
          { required: true, message: this.$t("请输入手机号"), trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    provinceRules() {
      return Array.isArray(this.provinceList) && this.provinceList.length > 0
        ? [{ required: true, message: this.$t('请输入省/州'), trigger: 'change' }]
        : [];
    },
    cityRules() {
      return Array.isArray(this.cityList) && this.cityList.length > 0
        ? [{ required: true, message: this.$t('请输入城市'), trigger: 'change' }]
        : [];
    }
  },
  created() {
    this.fetchAddressList();
    this.fetchDetail();
    this.loadUserPoints().catch(() => {});
  },
  methods: {
    async loadUserPoints() {
      try {
        const { getMyPoints } = await import("@/api/pointmall");
        const res = await getMyPoints({});
        const data = res && res.data ? res.data : {};
        const points =
          data.total ?? data.score ?? data.points ?? (data.user && data.user.points);
        this.commodityInfo.currentPoint = Number(points) || 0;
      } catch (e) {
        this.commodityInfo.currentPoint = 0;
      }
    },
    // 处理区号输入
    handleAreaInput() {
      this.addressForm.area = this.addressForm.area.replace(/\D/g, "");
    },
    // 处理手机号输入
    handlePhoneInput() {
      this.addressForm.phone = this.addressForm.phone.replace(/\D/g, "");
    },
    composeAddress(...parts) {
      return parts.filter(Boolean).join(" ");
    },
    async fetchDetail() {
      try {
        const id = this.$route.params.id;
        if (!id) return;
        const res = await getGoodsDetail({ tg_id: Number(id) });
        if (
          res &&
          (res.code === 200 || res.status === 200) &&
          res.data &&
          res.data.goods
        ) {
          const g = res.data.goods;
          const perUserCap = Number(g.tg_available_qty || 0);
          const exchangeLimit =
            typeof res.data.user_exchange_limit === "number"
              ? res.data.user_exchange_limit
              : perUserCap;
          this.commodityInfo = {
            id: g.tg_id || Number(id),
            name: g.tg_name || "",
            image: g.tg_main_image_attr || "",
            price: g.tg_ref_price || null,
            num: 1,
            value: g.tg_points || null,
            totalPrice: g.tg_points || null,
            currentPoint: Number(res.data.user_now_score ?? this.commodityInfo.currentPoint ?? 0),
            exchangeLimit,
            can_exchange_window: g.can_exchange_window ?? 0,
            can_exchange_by_user: res.data.can_exchange_by_user ?? 0,
            not_exchange_tips: g.tg_not_exchange_tips || "",
            expire: g.tg_end_time
              ? `${dayjs.unix(g.tg_end_time).format("YYYY-MM-DD")}`
              : "",
          };
        }
      } catch (e) {
        console.error("获取商品详情失败", e);
      }
    },
    async fetchAddressList() {
      try {
        const res = await addressList({});
        if (res && (res.code === 200 || res.status === 200)) {
          const list = Array.isArray(res.data)
            ? res.data
            : (res.data && res.data.list) || [];
          this.exchangeInfo = list.map((item) => ({
            tua_id: item.tua_id,
            name: item.tua_recipient_name,
            phone: item.tua_phone,
            address: item.tua_city_label + item.tua_district,
            addressDetail: item.tua_detail_address,
            postcode: item.tua_postal_code,
            is_default: Number(item.tua_is_default) === 1 ? 1 : 0,
            raw: item,
          }));
          const defIdx = this.exchangeInfo.findIndex((i) => i.is_default === 1);
          this.defaultAddressIndex = defIdx >= 0 ? defIdx : -1;
          this.selectedAddressIndex =
            defIdx >= 0 ? defIdx : this.exchangeInfo.length > 0 ? 0 : -1;
        } else {
          this.$message.error(res.msg || "获取地址列表失败");
        }
      } catch (e) {
        this.$message.error("地址列表接口异常");
      }
    },
    onAddAddress() {
      this.dialogMode = "add";
      this.editingId = null;
      this.dialogTableVisible = true;
      this.$nextTick(() => {
        this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
        this.addressForm.country = "";
        this.addressForm.postal = "";
        this.addressForm.addressinfo = "";
        this.addressForm.province = "";
        this.addressForm.city = "";
        this.addressForm.district = "";
        this.addressForm.info = "";
        this.addressForm.name = "";
        this.addressForm.phone = "";
        this.addressForm.area = "";
        this.addressForm.checked = false;
        // 初始化下拉数据
        this.countryList = [];
        this.provinceList = [];
        this.cityList = [];
        // 先获取国家列表
        this.fetchCountryList().then(() => {
          // 根据国家/省份/城市获取联动数据
          this.getAreaLists({
            act_country: this.addressForm.country,
            act_province: this.addressForm.province,
            act_city: this.addressForm.city,
          });
        });
      });
    },
    onEditAddress(item) {
      const raw = item.raw || {};
      this.dialogMode = "edit";
      this.editingId = raw.tua_id;
      this.dialogTableVisible = true;
      this.$nextTick(() => {
        this.$refs.ruleForm && this.$refs.ruleForm.clearValidate();
        this.addressForm.country = raw.tua_country || "";
        this.addressForm.postal = raw.tua_postal_code || "";
        this.addressForm.addressinfo = raw.tua_province || "";
        this.addressForm.province = raw.tua_province || "";
        this.addressForm.city = raw.tua_city || "";
        this.addressForm.district = raw.tua_district || "";
        this.addressForm.info = raw.tua_detail_address || "";
        this.addressForm.name = raw.tua_recipient_name || "";
        this.addressForm.phone = raw.tua_phone || "";
        this.addressForm.area = raw.tus_area_code || "";
        this.addressForm.checked = Number(raw.tua_is_default) === 1;
        // 预填充下拉数据
        this.fetchCountryList().then(() => {
          this.getAreaLists({
            act_country: this.addressForm.country,
            act_province: this.addressForm.province,
            act_city: this.addressForm.city,
          });
        });
      });
    },
    async onDeleteAddress(item) {
      const id = item.tua_id || (item.raw && item.raw.tua_id);
      if (!id) return;
      try {
        await this.$confirm(
          this.$t("确认删除该地址吗") + "？",
          this.$t("提示"),
          { type: "warning" }
        );
        const res = await addressDelete({ tua_id: id });
        if (res && (res.code === 200 || res.status === 200)) {
          this.$message.success(this.$t("删除成功"));
          this.fetchAddressList();
        } else {
          this.$message.error(res.msg || this.$t("删除失败"));
        }
      } catch (e) {
        // 用户取消
      }
    },
    handleDialogCancel() {
      this.dialogTableVisible = false;
    },
    handleDialogOk() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) return;
        const payload = {
          tua_country: this.addressForm.country,
          tua_postal_code: this.addressForm.postal,
          tua_province: this.addressForm.province,
          tua_city: this.addressForm.city,
          tua_district: this.addressForm.district,
          tua_detail_address: this.addressForm.info,
          tua_recipient_name: this.addressForm.name,
          tus_area_code: this.addressForm.area,
          tua_phone: this.addressForm.phone,
          tua_is_default: this.addressForm.checked ? 1 : 0,
        };
        if (this.dialogMode === "edit" && this.editingId) {
          payload.tua_id = this.editingId;
        }
        try {
          const res = await addressSave(payload);
          if (res && (res.code === 200 || res.status === 200)) {
            this.$message.success(this.$t("保存成功"));
            this.dialogTableVisible = false;
            this.fetchAddressList();
          } else {
            this.$message.error(res.msg || this.$t("保存失败"));
          }
        } catch (e) {
          this.$message.error(this.$t("保存接口异常"));
        }
      });
    },
    async handleSubmitOrder() {
      // 校验地址选择
      if (
        this.selectedAddressIndex < 0 ||
        !this.exchangeInfo[this.selectedAddressIndex]
      ) {
        this.$message.warning(this.$t("请选择收货地址"));
        return;
      }
      // 校验商品与兑换状态
      const info = this.commodityInfo;

      // 数量与积分校验
      const quantity = Math.max(1, Number(info.num) || 1);
      const totalPoints = (Number(info.value) || 0) * quantity;

      const address = this.exchangeInfo[this.selectedAddressIndex];
      const params = {
        tg_id: Number(info.id),
        tua_id: Number(address.tua_id),
        quantity,
      };
      try {
        const res = await exchange(params);
        if (res && (res.code === 200 || res.status === 200)) {
          // 下单成功，弹窗提示
          this.dialogsubmitVisible = true;
          // 成功后延时返回列表页
          setTimeout(() => {
            this.dialogsubmitVisible = false;
            this.$router.push({ name: "POINTMALL_LIST" });
          }, 4000);
        } else {
          if (res && res.status === 201) {
            return;
          }
          this.$message.error(res.msg || this.$t("提交失败"));
        }
      } catch (e) {
        this.$message.error(this.$t("下单接口异常"));
      }
    },
    // 变更国家
    async handleChangecountry() {
      this.addressForm.province = "";
      this.addressForm.city = "";
      this.provinceList = [];
      this.cityList = [];
      const val = this.addressForm.country;
      const opt =
        this.countryList.find((o) => String(o.value) === String(val)) || {};
      const label = String(opt.label || opt.name || val || "").toLowerCase();
      if (!this.addressForm.area) {
        if (label === "中国" || label === "cn" || label === "china") {
          if (this.dialogMode === "add") this.addressForm.area = "86";
        } else {
          this.addressForm.area = "";
        }
      }
      // 使用用户中心接口获取省份列表（type=3）
      if (this.addressForm.country) {
        try {
          const res = await getDistrict(3, this.addressForm.country);
          if (res && (res.code === 200 || res.status === 200)) {
            this.provinceList = res.data || res || [];
          }
        } catch (e) {}
      }
    },
    // 变更省份
    async handleChangeprovince() {
      this.addressForm.city = "";
      this.cityList = [];
      // 使用用户中心接口获取城市列表（type=4）
      if (this.addressForm.province) {
        try {
          const res = await getDistrict(4, this.addressForm.province);
          if (res && (res.code === 200 || res.status === 200)) {
            this.cityList = res.data || res || [];
          }
        } catch (e) {}
      }
    },
    // 变更城市
    handleChangecity() {
      // 如需联动区县，这里可扩展
    },
    // 仅获取国家列表
    async fetchCountryList() {
      try {
        const res = await getQuestionCountry();
        if (res && (res.code === 200 || res.status === 200)) {
          this.countryList = res.data.country_list || res.country_list || [];
        }
      } catch (e) {}
    },
    // 获取省/市数据（根据已选国家/省），改为使用 get_district
    async getAreaLists(obj) {
      // 根据国家取省份
      if (obj && obj.act_country) {
        try {
          const resP = await getDistrict(3, obj.act_country);
          if (resP && (resP.code === 200 || resP.status === 200)) {
            this.provinceList = resP.data || resP || [];
          }
        } catch (e) {}
      } else {
        this.provinceList = [];
      }
      // 根据省份取城市
      if (obj && obj.act_province) {
        try {
          const resC = await getDistrict(4, obj.act_province);
          if (resC && (resC.code === 200 || resC.status === 200)) {
            this.cityList = resC.data || resC || [];
          }
        } catch (e) {}
      } else {
        this.cityList = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep() {
  .el-form-item__error {
    padding-top: 1px !important;
  }

  .el-select {
    width: 100%;
  }

  .submit-dialog {
    border-radius: 12px;

    .el-dialog__header .el-dialog__title {
      display: none;
    }

    .el-icon-close:before {
      font-size: 22px;
    }

    .el-dialog__headerbtn {
      top: 26px;
    }
  }

  .address-dialog {
    border-radius: 12px;

    .el-dialog__header {
      padding: 28px 30px 18px;
    }

    .el-dialog__body {
      padding: 0 30px;
    }

    .el-form-item {
      margin-bottom: 8px !important;

      .el-checkbox:hover {
        .el-checkbox__label {
          color: #b7251e;
        }
      }

      .el-checkbox__label {
        color: #191919;
      }

      .el-input__inner,
      .el-textarea__inner {
        &::placeholder {
          color: #aeaeae;
          font-size: 14px !important;
        }

        border-color: #c9c9c9;

        transition: border-color 0.2s;

        &:hover {
          border-color: #b7251e;
        }
      }

      .el-textarea__inner {
        min-height: 73px !important;
      }
    }

    .el-form--label-top .el-form-item__label {
      font-size: 14px;
      color: #595959;
      line-height: 24px !important;
      padding: 0 !important;
    }

    .el-input__inner {
      height: 30px;
      line-height: 30px;
    }

    .el-dialog__footer {
      padding-top: 32px;
    }

    .dialog-footer {
      button {
        height: 32px !important;
        line-height: 30px !important;
        padding: 0 16px;
        min-width: 92px;
        border-radius: 30px;
      }
    }
  }
}

.exchange-exchange {
  background: #ffffff;
  border-radius: 8px;
  margin-top: 20px;
  padding: 24px 40px 32px;

  .commodity {
    width: 100%;
    border-radius: 8px;
    border: 1px solid #c9c9c9;
    margin-top: 24px;
    padding: 24px;

    .left-img {
      width: 220px;
      height: 220px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 8px;
        object-fit: cover;
      }
    }

    .right-text {
      .ml-100 {
        margin-left: 100px;
      }

      .ml-70 {
        margin-left: 70px;
      }

      .value-text::before {
        display: inline-block;
        content: "\e627";
        font-size: 20px;
        line-height: 24px;
        margin-right: 8px;
        font-family: "iconfont";
      }
    }
  }
}

.exchange {
  min-height: calc(100vh - 280px);
  padding-top: 84px;
  padding-bottom: 60px;
  background: #f9f9f9;

  .address-addbtn {
    color: #191919;
    font-family: "harmonyos";
    font-size: 16px;

    &:hover {
      color: #d80f05;
    }
  }

  .btn-box {
    margin-top: 40px;

    .btn {
      min-width: 140px;
      height: 48px;
      border-radius: 40px;
      font-size: 16px !important;
      // font-family: "harmonyos" !important;
      font-weight: 350 !important;
    }
  }

  .exchange-info {
    max-width: 1400px;
    margin: 0 auto;

    .exchange-address {
      background: #ffffff;
      border-radius: 8px;
      padding: 24px 40px;

      .exchange-address-item {
        width: calc(25% - 16px);
        border-radius: 8px;
        border: 1px solid #c9c9c9;
        padding: 16px 28px 16px 16px;
        margin-top: 16px;
        font-family: "harmonyos";
        color: #191919;
        line-height: 22px;
        margin-right: 16px;
        transition: all 0.36s;
        cursor: pointer;
        position: relative;

        .close-btn {
          position: absolute;
          right: 8px;
          top: 6px;
          font-size: 18px;
          color: #666;

          &:hover {
            color: #191919;
          }
        }

        .edit-btn {
          padding: 0;
          color: #666666;
          position: relative;
          right: -16px;
          font-size: 14px;

          &:hover {
            color: #d80f05;
          }
        }

        &:nth-child(4n) {
          margin-right: 0;
        }

        &:hover,
        &.active {
          border-color: #d80f05;
        }

        .ipt-active {
          display: inline-block;
          height: 20px;
          border-radius: 4px;
          background: #fcf4f3;
          color: #d80f05;
          font-size: 12px;
          padding: 0 4px;
        }
      }
    }
  }
}
</style>
